import { AppServices } from "./AppServices";
import { CookiesStorage } from "./BrowserStorage";

export class AddressPageController {
   private appServices_ = new AppServices();

   private registered = false;
   private active = false;
   private handleFocusOut = (e: FocusEvent) => {
      if (!this.active)
         return;

      const el = e.target as HTMLInputElement;
      if (el.classList.contains('manual-validation')) {
         el.dataset.touched = "true";
      }
   };
   private handleInput = (event: Event): void => {
      if (!this.active)
         return;

      const target = event.target as HTMLElement;

      //|| target instanceof HTMLTextAreaElement
      if (target instanceof HTMLInputElement) {
         // 1. Remove Bootstrap's error class from the input itself
         target.classList.remove('is-invalid');
         target.classList.remove('invalid');

         // 2. Find the validation message
         // We search the parent for the error class to handle various layouts
         const parent = target.parentElement;
         if (parent) {
            // Look for Blazor or Bootstrap error elements within the same container
            const errorElements = parent.querySelectorAll('.validation-message'); //, .invalid-feedback
            errorElements.forEach((el) => {
               (el as HTMLElement).style.display = 'none';
            });
         }
         // Only run on fields that opted-in with our class
         const el = target;
         if (el.dataset.touched === "true" &&
            el.classList.contains('validation-manual')) {
            this.validateField(el);
         }
      }
   };
   constructor(appServices: AppServices) {
      this.appServices_ = appServices;
   }

   private validateField(el: HTMLInputElement) {
      const patternAttr = el.getAttribute('pattern');
      if (!patternAttr) return;

      // Create regex from the pattern attribute
      const regex = new RegExp(patternAttr);
      const isValid = regex.test(el.value);

      if (isValid) {
         // Perfect match: Go Green & Clear Server Errors
         el.classList.remove('is-invalid', 'invalid');
         el.classList.add('is-valid', 'valid');

         const msg = el.parentElement?.querySelector('.validation-message') as HTMLElement;
         if (msg) msg.style.display = 'none';
      } else {
         // Not a match yet: Remove green                  
         el.classList.add('is-invalid', 'invalid');
         el.classList.remove('is-valid', 'valid');
      }
   }

   
   public onLoad(): void {
      
      const form = document.getElementById('form-shippingAddress');
      if (!form) {
         //if (this.registered) {
         //   document.removeEventListener('focusout', this.handleFocusOut, true);
         //   document.removeEventListener('input', this.handleInput, true);
         //   this.registered = false;
         //}
         this.active = false;
         return;
      }

      this.active = true;
      this.initAddressType();
      const inpEmail = document.getElementById('inp-email') as HTMLInputElement;
      if (inpEmail) {
         //const emailPattern = "^(([^<>()[\\\\\\]\\\\.,;:\\s@\"]+(\\.[^<>()[\\\\\\]\\\\.,;:\\s@\"]+)*)|(\".+\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$";
         const emailPattern = "[a-zA-Z0-9._%+\\-]+@[a-zA-Z0-9\\-]+(\\.[a-zA-Z0-9\\-]+)*\\.[a-zA-Z]{2,}";
         inpEmail.setAttribute('pattern', emailPattern);
      }

      if (!this.registered) {         
         document.addEventListener('focusout', this.handleFocusOut, true);            
         document.addEventListener('input', this.handleInput);
         this.registered = true;
      }

      let firstInvalid = form.querySelector('input.invalid') as HTMLInputElement | null;
      if (!firstInvalid)
         firstInvalid = form.querySelector('input.is-invalid') as HTMLInputElement | null;
      //if (!firstInvalid)
      //   firstInvalid = form.querySelector(':invalid') as HTMLInputElement | null;
      if (firstInvalid) {
         firstInvalid.classList.add('is-invalid');
         firstInvalid.focus();
         firstInvalid.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
         });
      }
   }

   private initAddressType(): void {
      const elCheck = document.getElementById('inp-isCompany') as HTMLInputElement | null;
      if (!elCheck) return;

      const elCurId = elCheck.checked ? 'btn-addr-comp' : 'btn-addr-priv';
      const elOtherId = !elCheck.checked ? 'btn-addr-comp' : 'btn-addr-priv';
      const elCur = document.getElementById(elCurId) as HTMLInputElement | null;
      if (!elCur) return;

      this.onAddressType(elCur, elOtherId, elCheck.checked, 'inp-isCompany', 'inp-company', 'div-company');
   }

   public onAddressType(
      elType: HTMLInputElement,
      elTypeOtherId: string,
      isCompany: boolean,
      elCheckId: string,
      elEditId: string,
      elContainerId: string): void {

      const elTypeOther = document.getElementById(elTypeOtherId) as HTMLInputElement | null;
      if (!elTypeOther) return;

      const elEdit = document.getElementById(elEditId) as HTMLInputElement | null;
      if (!elEdit) return;

      const elCheck = document.getElementById(elCheckId) as HTMLInputElement | null;
      if (!elCheck) return;

      const container = document.getElementById(elContainerId);

      elType.classList.remove('btn-outline-secondary');
      elType.classList.add('btn-info');

      elTypeOther.classList.remove('btn-info');
      elTypeOther.classList.add('btn-outline-secondary');

      elCheck.checked = isCompany;
      this.onCompanyAddress(elCheck, elEditId, elContainerId);
   }

   public onCompanyAddress(elCheck: HTMLInputElement, elEditId: string, elContainerId: string): void {
      const el = document.getElementById(elEditId) as HTMLInputElement | null;
      if (!el) return;
      const container = document.getElementById(elContainerId);
      
      const isChecked = elCheck.checked;
      el.disabled = !isChecked;
      el.style.display = isChecked ? '' : 'none';

      if (container) {
         container.style.display = isChecked ? '' : 'none';
      }

      // Toggle required attribute
      el.toggleAttribute('required', isChecked);

      // Add/remove minlength and maxlength
      if (isChecked) {
         el.setAttribute('minlength', '2');
         el.setAttribute('maxlength', '30');
      } else {
         el.removeAttribute('minlength');
         el.removeAttribute('maxlength');
         el.classList.remove('invalid');
         el.classList.remove('is-invalid');
      }

      const form = el.closest('form');
      if (form) {
         form.classList.remove('was-validated');
      }      
   }

   public onPersistAddress(elCheck: HTMLInputElement): void {
      if (!elCheck.checked) {
         const cookieStorage = new CookiesStorage();
         cookieStorage.remove('bu-sha');
      }
   }

   public validate(event: Event, elSubmitId: string): boolean {      
      const form = document.getElementById(elSubmitId) as HTMLFormElement | null;

      if (!form) {
         //console.error(`Form with id "${elSubmitId}" not found.`);
         return false;
      }

      const manualFields = form.querySelectorAll('.manual-validation') as NodeListOf<HTMLInputElement>;

      manualFields.forEach(field => {
         field.dataset.touched = "true";         
         this.validateField(field);
      });
     
      const isFormValid = form.checkValidity();
      
      if (!isFormValid) {
         // Stop the Blazor Enhanced SSR submission
         event.preventDefault();
         event.stopPropagation();

         // Trigger Bootstrap's CSS pseudo-classes (:invalid)
         form.classList.add('was-validated');

         const invalids = form.querySelectorAll(':invalid');
         invalids.forEach((el) => {
            const input = el as HTMLInputElement;
            const msg_err = input.getAttribute('data-bu-err') || input.title;
            // Find the validation message div (works with Blazor's ValidationMessage)
            const feedback = input.parentElement?.querySelector('.invalid-feedback') ||
               input.closest('.form-group')?.querySelector('.invalid-feedback') ||
               input.parentElement?.querySelector('.validation-message');

            if (feedback) {
               if (input.validity.valueMissing) {
                  feedback.textContent = 'Pole jest wymagane';
               } else if (input.validity.tooShort) {
                  feedback.textContent = `Minimum ${input.minLength} znaki`;
               } else if (input.validity.tooLong) {
                  feedback.textContent = `Maksimum ${input.maxLength} znak�w`;
               } else if (input.validity.patternMismatch) {
                  feedback.textContent = msg_err || 'Niepoprawny format';
               }
            }
         });

         const firstInvalid = form.querySelector(':invalid') as HTMLElement | null;
         if (firstInvalid) {
            firstInvalid.focus();
            firstInvalid.scrollIntoView({
               behavior: 'smooth',
               block: 'center'
            });
         }

         return false;
      }

      // Success: Allow the event to continue to Blazor's handler
      //form.classList.add('was-validated');
      return true;
   }
}